import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documark-for-universities',
  templateUrl: './documark-for-universities.component.html',
  styleUrls: ['./documark-for-universities.component.scss']
})
export class DocumarkForUniversitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
